(() => {
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const money = c => (window.BC && BC.moneyFormat ? BC.moneyFormat : '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
  const v = (c / 100); return k === 'amount_no_decimals' ? Math.round(v).toLocaleString('en-US') : v.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
});
const hdr = $('.hdr');
const setH = () => hdr && document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
setH(); addEventListener('resize', setH);

/* reveal */
const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), {rootMargin: '0px 0px -6% 0px'});
const observe = (root = document) => $$('.reveal:not(.in)', root).forEach(el => io.observe(el));
observe();

/* drawers */
const drawer = $('[data-cart]'), menu = $('[data-menu]'), scrim = $('[data-scrim]');
const open = d => { if (!d) return; d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); scrim.hidden = false; document.body.style.overflow = 'hidden'; };
const closeAll = () => { [drawer, menu].forEach(d => { if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); } }); if (scrim) scrim.hidden = true; document.body.style.overflow = ''; };
$('[data-open-menu]')?.addEventListener('click', () => open(menu));
$('[data-open-cart]')?.addEventListener('click', e => { e.preventDefault(); renderCart().then(() => open(drawer)); });
scrim?.addEventListener('click', closeAll);
$$('.drawer [data-close]').forEach(b => b.addEventListener('click', closeAll));
addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

/* search */
const sb = $('[data-search-bar]');
$('[data-search]')?.addEventListener('click', () => { sb.hidden = !sb.hidden; if (!sb.hidden) $('[data-search-input]').focus(); });

/* toast */
let tt; const toast = m => { const t = $('[data-toast]'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 2200); };

/* cart */
async function renderCart() {
  const c = await fetch('/cart.js').then(r => r.json());
  $$('[data-cart-count]').forEach(el => el.textContent = c.item_count);
  $('[data-cart-total]').textContent = money(c.total_price);
  const body = $('[data-cart-items]');
  body.innerHTML = c.items.length ? c.items.map(i => `
    <div class="ci"><img src="${i.image ? i.image + (i.image.includes('?') ? '&' : '?') + 'width=200' : ''}" alt=""><div><a href="${i.url}"><h5>${i.product_title}</h5></a>${i.product_has_only_default_variant ? '' : `<div class="v">${i.variant_title}</div>`}
      <div class="qty"><button data-q="${i.key}" data-n="${i.quantity - 1}" aria-label="Decrease">−</button><span>${i.quantity}</span><button data-q="${i.key}" data-n="${i.quantity + 1}" aria-label="Increase">+</button></div></div>
      <div>${money(i.final_line_price)}</div></div>`).join('')
    : '<div class="empty"><b>Your bag is empty</b>Start with a card for someone starting over.</div>';
  const note = $('[data-pay-note]');
  if (note) note.textContent = c.total_price >= 3500 ? `Or 4 interest-free payments of ${money(c.total_price / 4)} at checkout, where available.` : c.item_count ? `Add ${money(3500 - c.total_price)} more to unlock 4 interest-free payments.` : '';
  $$('[data-q]', body).forEach(b => b.onclick = async () => {
    await fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: b.dataset.q, quantity: +b.dataset.n})});
    renderCart();
  });
}
$$('form[data-ajax-add]').forEach(f => f.addEventListener('submit', async e => {
  e.preventDefault();
  const btn = f.querySelector('[type=submit]'); btn.disabled = true;
  const err = f.querySelector('[data-add-error]'); if (err) err.textContent = '';
  try {
    const r = await fetch('/cart/add.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(f)});
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || 'Could not add to bag.');
    await renderCart(); open(drawer); toast(`Added: ${d.product_title}`);
  } catch (x) { if (err) err.textContent = x.message; }
  btn.disabled = false;
}));
$$('.opts input[type=radio]').forEach(r => r.addEventListener('change', () => {
  $$('.opts .opt').forEach(o => o.classList.toggle('on', o.querySelector('input').checked));
}));

/* card tone filter */
$$('[data-tone]').forEach(b => b.addEventListener('click', () => {
  const t = b.dataset.tone;
  $$('[data-tone]').forEach(x => x.classList.toggle('on', x === b));
  $$('[data-tone-sec]').forEach(s => s.hidden = !(t === 'all' || s.dataset.toneSec === t));
  const n = $('.card-nav'); if (n) scrollTo({top: n.getBoundingClientRect().top + scrollY - (hdr ? hdr.offsetHeight : 0) - 8, behavior: 'smooth'});
}));
$$('.coll-chips .chip.on').forEach(c => c.scrollIntoView({inline: 'center', block: 'nearest'}));

/* recommendations: complementary first, related fallback */
const rec = $('[data-recs]');
if (rec) (async () => {
  for (const url of [rec.dataset.url, rec.dataset.fallback]) {
    try { const html = await fetch(url).then(r => r.text()); const d = document.createElement('div'); d.innerHTML = html;
      if (d.querySelector('[data-has-recs]')) { rec.innerHTML = d.querySelector('[data-has-recs]').outerHTML; observe(rec); return; } } catch (e) {}
  }
})();

/* open drawer after customer form posts land back on page */
if (location.search.includes('customer_posted=true')) { const m = $('.form-msg, .preorder'); m && m.scrollIntoView({block: 'center'}); }
})();
